export function resolveContextualRequestCompletion(kind: "install_return" | "price_alert" | null) {
  if (kind === "install_return") return "install_intent" as const;
  if (kind === "price_alert") return "price_alert_request" as const;
  return null;
}
